import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@constants/routes';
import RegisterFeature from '@features/register';
import { useRegisterForm } from '@features/register/register-page-context';
import { useFormStore } from '@store/use-form-store';

import type { RegisterFormData, Registrant } from '@types';

function VisitorRegisterPage() {
  const navigate = useNavigate();
  const formProps = useRegisterForm();
  const { registeredPersons, setRegisteredPersons } = useFormStore();
  const [editRegistrantId, setEditRegistrantId] = useState<string | null>(null);

  const addRegistrant = (r: Registrant) =>
    setRegisteredPersons([...registeredPersons, r]);
  const removeRegistrant = (docNo: string) =>
    setRegisteredPersons(registeredPersons.filter((p) => p.docNo !== docNo));
  const updateRegistrant = (r: Registrant) =>
    setRegisteredPersons(
      registeredPersons.map((p) => (p.docNo === editRegistrantId ? r : p))
    );

  const onValidSubmit = (formData: RegisterFormData) => {
    setRegisteredPersons([formData as Registrant]);
    navigate(ROUTES.VR_VIDEO);
    return Promise.resolve();
  };

  return (
    <RegisterFeature
      {...formProps}
      registeredPersons={registeredPersons}
      editRegistrantId={editRegistrantId}
      setEditRegistrantId={setEditRegistrantId}
      addRegistrant={addRegistrant}
      removeRegistrant={removeRegistrant}
      updateRegistrant={updateRegistrant}
      onValidSubmit={onValidSubmit}
      onDataProtectionDecline={() => {
        navigate(ROUTES.VR_WELCOME);
      }}
      isSubmitting={false}
      onPreviousPage={() => navigate(ROUTES.VR_WELCOME)}
    />
  );
}

export default VisitorRegisterPage;
